export default __webpack_public_path__ + "static/memoji-885f51ff1b0680b229c8a39f11383a84.png";